import React from 'react';
import styled from 'styled-components';
import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

//import './index.scss';

type ProductProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const Product = (componentProps: ProductProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  [props] = processComponentProps(props, dataElementContext);

  const [state, setState] = React.useState({
    expanded: false,
  });

  const onToggleExpanded = React.useCallback((e: React.MouseEvent<HTMLElement>) => {
    setState((prevState) => ({ ...prevState, expanded: !prevState.expanded }));
  }, []);

  const onActionChange = React.useCallback((e: React.MouseEvent<HTMLElement>) => {
    const actionId = e?.currentTarget?.dataset?.id ?? null;
    const actionValue = e?.currentTarget?.dataset?.value ?? null;
  }, []);

  const contextValue = React.useMemo(() => {
    return {
      data: {
        generalStats: {
          overall: {
            value: 55,
            requiredActions: 0,
          },
          marketScore: {
            value: 84,
            requiredActions: 0,
          },
          profitability: {
            value: 48,
            requiredActions: 0,
          },
          stickiness: {
            value: 95,
            requiredActions: 0,
          },
        },

        inactiveProductsExpanded: state.expanded,
        inactiveProducts: [
          {
            id: 'prod-001',
            name: 'Super8',
            type: 'super8',
            status: 'inactive',
            level: 0,

            maxLevel: 3,
            // value between 0-100
            vsLevel: 0,
            marketLevel: 60,
            unlock: [
              {
                label: 'Market Score',
                value: '+7%',
              },
              {
                label: 'Monetization',
                value: '+5%',
              },
              {
                label: 'Retention',
                value: '+10%',
              },
            ],
          },
          {
            id: 'prod-002',
            name: 'AirTimer',
            type: 'airtimer',
            status: 'inactive',
            level: 0,
            maxLevel: 3,
            // value between 0-100
            vsLevel: 0,
            marketLevel: 55,
            unlock: [
              {
                label: 'Market Score',
                value: '+5%',
              },
              {
                label: 'Monetization',
                value: '+14%',
              },
              {
                label: 'Retention',
                value: '+2%',
              },
            ],
          },
          {
            id: 'prod-003',
            name: 'Shop',
            type: 'shop',
            status: 'inactive',
            level: 0,
            maxLevel: 3,
            // value between 0-100
            vsLevel: 0,
            marketLevel: 75,
            unlock: [
              {
                label: 'Market Score',
                value: '+7%',
              },
              {
                label: 'Monetization',
                value: '+6%',
              },
              {
                label: 'Retention',
                value: '+10%',
              },
            ],
          },
          {
            id: 'prod-007',
            name: 'Turbo Cash',
            type: 'turbocash',
            status: 'inactive',
            level: 0,
            maxLevel: 3,
            // value between 0-100
            vsLevel: 0,
            marketLevel: 55,
            unlock: [
              {
                label: 'Market Score',
                value: '+9%',
              },
              {
                label: 'Monetization',
                value: '+3%',
              },
              {
                label: 'Retention',
                value: '+21%',
              },
            ],
          },
        ],
        activeProducts: [
          {
            id: 'prod-004',
            name: 'Happy Hour',
            type: 'happyhour',
            status: 'active',
            level: 1,
            maxLevel: 3,
            // value between 0-100
            vsLevel: 33,
            marketLevel: 66,
            unlock: [
              {
                label: 'Market Score',
                value: '+2%',
              },
              {
                label: 'Monetization',
                value: '+12%',
              },
              {
                label: 'Retention',
                value: '+6%',
              },
            ],
          },
          {
            id: 'prod-005',
            name: 'Challenges',
            type: 'challenges',
            status: 'active',
            level: 2,
            maxLevel: 3,
            // value between 0-100
            vsLevel: 45,
            marketLevel: 75,
            unlock: [
              {
                label: 'Market Score',
                value: '+5%',
              },
              {
                label: 'Monetization',
                value: '+10%',
              },
              {
                label: 'Retention',
                value: '+9%',
              },
            ],
          },
          {
            id: 'prod-006',
            name: 'Tournaments',
            type: 'tournaments',
            status: 'active',
            level: 3,
            maxLevel: 3,
            // value between 0-100
            vsLevel: 100,
            marketLevel: 60,
            unlock: [
              {
                label: 'Market Score',
                value: '+11%',
              },
              {
                label: 'Monetization',
                value: '+12%',
              },
              {
                label: 'Retention',
                value: '+11%',
              },
            ],
          },
        ],
      },
      actions: {
        onActionChange,
        onToggleExpanded,
      },
      parentContext: dataElementContext,
    };
  }, [dataElementContext, onActionChange, onToggleExpanded, state.expanded]);

  console.log('oh.module.product[contextValue]', contextValue);

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default Product;
